import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import routes from './application/routes';
import HelpIconInjector from './common/components/HelpIcon/HelpIconInjector';
import ChatbotPanel from './common/components/ChatbotPanel';

const App: React.FC = () => {
  const location = useLocation();
  const renderRoutes = (routeList: any[]): React.ReactNode => {
    return routeList.map((route, index) => {
      if (route.children) {
        return (
          <Route key={index} path={route.path} element={route.element} errorElement={route.errorElement}>
            {renderRoutes(route.children)}
          </Route>
        );
      }
      return (
        <Route
          key={index}
          path={route.path}
          element={route.element}
          index={route.index}
        />
      );
    });
  };

  return (
    <>
      <Routes>{renderRoutes(routes)}</Routes>
      {/* Pass the live path so the injector only renders help whose stored
          pageurl matches the current route (prevents one page's help — e.g. e09 —
          leaking onto another like /cn54bis-cn56-summary now that all sections
          share the `section-bar-help-anchor` data-testid). */}
      <HelpIconInjector pageUrl={location.pathname} />
      <ChatbotPanel/>
    </>
  );
};

export default App;
